/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useCallback, useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { createTask, updateTaskList } from '../../Components/action/common'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateAllTaskList,
  updateGroupedList,
  updateNoDateTaskList,
  updateOverDueTaskList,
  updateSetTaskList,
  updateCompletedTaskList,
  pushGroupedList,
  pushOverDueTaskList,
  pushAllTaskList,
  pushNoDateTaskList,
  pushCompletedTaskList,
  pushSetTaskList,
  setTaskProjects
} from '../../redux/slices/TaskSlice'
import moment from 'moment'
import { jsx } from "@emotion/core";
import Datepicker from '../../Components/DatePicker/components/Datepicker'
import CalendarIcon from './CalendarIcon'
import { format, isValidDate, removeMentionsAndConvertToHTML, extractMentions, getEditorContent } from '../../Components/action/utilities'
import Select from 'react-select'
import RepeatedTaskModal from '../Settings/Modal/RepeatedTaskModal'
import { RRule, rrulestr } from 'rrule'
import momentTimezone from 'moment-timezone';
import ConfirmRecurringTask from '../Tasks/ConfirmRecurringTask'
import { SaveIcon } from '../../Components/LandingHeader/Feedback/icons/Icons'
import { fetchProjectList } from '../../Components/action/tasks'
import { setAllProjectsList } from '../../redux/slices/ProjectSlice'
import { usePosthog } from '../../PosthogProvider'
import MediumLikeEditorWithMentions from '../../Components/common/MediumLikeEditorWithMentions'
import Tooltip from '../../Components/common/Tooltip'
// import { setAllGoalsList } from '../../redux/slices/GoalSlice'
// import { fetchGoalList } from '../../Components/action/goals'
import DateTimePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

function EditTaskList({
  groupDate = "",
  setEditTaskId = (e) => {},
  currentPage,
  hideActions = false,
  setSelectedDate = (e) => {},
  item,
  setEditTaskListData = (e) => {},
  fetchAddTaskData,
  reloadProjectTasks = () => {},
  setUpdatedValue = (e) => {},
  onlyRecurringTasks = false
 }) {

  const dispatch = useDispatch()
  const projectOptionsRef = useRef(null);
  // const titleRef = useRef();
  const editorRef = useRef();
  const { dateChange, taskDaySelected, taskProjects } = useSelector(state => state.task)
  const { allProjectsList } = useSelector(state => state.project)
  // const { allGoalsList } = useSelector(state => state.goal)
  const [titleValue, setTitle] = useState(item?.title)
  const [taskDescription, setTaskDescription] = useState(item?.description ?? '')
  const tmpDate = item?.repeat?.rule ? (groupDate ? groupDate : dateChange) : item?.date;
  const [dateRange, setDateRange] = useState(tmpDate ? new Date(tmpDate) : null)
  const [datePickerValue, setDatePickerValue] = useState(new Date())
  const [taskDate, setTaskDate] = useState(tmpDate)
  const [editTaskSelected, setEditTaskSelected] = useState(taskDaySelected)
  const {  colorPicker, colorPickerDark, theme } = useSelector(state => state.theme)
  const dateTime = moment(dateRange).format('YYYY-MM-DD')
  const [autoFocus, setAutoFocus] = useState(false);
  const [selectedRepeat, setSelectedRepeat] = useState(item?.repeat?.value ?? 1);
  const [repeatListOptions, setRepeatListOptions] = useState([]);
  const [openCustomRepeat, setOpenCustomRepeat] = useState(false);
  const [editRecurringTask, setEditRecurringTask] = useState(false)
  const [selectedProject, setSelectedProject] = useState(item?.Project?.title ?? null);
  const repeatOptionsRef = useRef(null);
  const { captureEvent } = usePosthog();
  // const [onStartTimeChange, setOnStartTimeChange] = useState(item?.date ? moment(item?.date).toDate() : null);
  // const [onEndTimeChange, setOnEndTimeChange] = useState(item?.endDateTime ? moment(item?.endDateTime).toDate() : null);

  const initRepeatListOptions = useCallback(() => {
    const TaskDate = {
      from: dateRange || new Date()
    }
    const dtstart = momentTimezone(TaskDate?.from).tz(momentTimezone.tz.guess()).endOf('day').toDate()
    let selectRepeatList = [
      { value: 1, label: `Does not repeat`, rule: null },
      { value: 2, label: `Daily`, rule: (new RRule({dtstart, freq: RRule.DAILY})).toString() },
      { value: 3, label: `Weekly on ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.WEEKLY, interval: 1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 4, label: `Monthly on the first ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.MONTHLY, interval: 1, bysetpos: 1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 5, label: `Monthly on the last ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.MONTHLY, interval: 1, bysetpos: -1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 6, label: `Annually on ${TaskDate?.from && format(TaskDate.from, "MMMM DD")}`, rule: (new RRule({dtstart, freq: RRule.YEARLY, interval: 1})).toString() },
      { value: 7, label: `Every weekday (Monday to Friday)`, rule: (new RRule({dtstart, freq: RRule.WEEKLY, byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR]})).toString() },
      { value: 99, label: null, rule: null },
      { value: 100, label: `Custom...`, rule: null }
    ];

    if(onlyRecurringTasks){
      selectRepeatList = selectRepeatList.filter(item => item.value !== 1);
      setSelectedRepeat(item?.repeat?.value ?? 2)
    }else{
      setSelectedRepeat(item?.repeat?.value ?? 1)
    }

    setRepeatListOptions(selectRepeatList.map(option => option.value == item?.repeat?.value ? item.repeat : option))
  }, [dateRange]);

  const onAddTaskUpdateHandler = () => {
    const updatedDate = getUpdatedDate();
    const updatedRule = repeatListOptions.filter(item => item.value === selectedRepeat)?.[0]?.rule ?? null;
    const isUpdatedDateSame = moment(updatedDate ?? new Date()).isSame(moment(item?.date ?? new Date()))
    const isUpdatedRuleSame = item?.repeat?.rule === updatedRule;

    if(item?.repeat?.rule && typeof item?.repeat?.value != 'undefined' && item?.repeat?.value != '1' && item?.date !== null){
      if(isUpdatedRuleSame){
        if(isUpdatedDateSame){
          setEditRecurringTask(true)
        }else{
          onAddTaskUpdate(item, 1)
        }
      }else{
        onAddTaskUpdate(item, 3)
      }
    }else{
      onAddTaskUpdate(item);
    }
  }

  const getUpdatedDate = () => {
    let date = new Date(moment().startOf('date')).toISOString()
    try{
      if (editTaskSelected === 'Today') {
        date = new Date(moment().startOf('date')).toISOString()
      } else if (editTaskSelected === 'Tomorrow') {
        date = moment(date).add(1, 'days').toISOString()
      } else if (editTaskSelected === 'Next Week') {
        date = moment(date).add(7, 'days').toISOString()
      } else if (editTaskSelected === 'No Date') {
        date = null
      }else{
        date = new Date(moment(dateRange).startOf('date')).toISOString()
      }
    }catch(e){
      date = null
    }

    return date;
  }

  const onAddTaskUpdate = async (item, recurring = null) => {
    setEditRecurringTask(false)
    setEditTaskId(null);
    
    let date = getUpdatedDate();
    const taskDescription = getEditorContent('description', editorRef);
    const title = removeMentionsAndConvertToHTML('title', editorRef);
    // const { projectMentions: projects, goalMentions: goals} = extractMentions("title", editorRef);
    const { projectMentions: projects} = extractMentions("title", editorRef);
    const project = projects?.[0]?.name ?? selectedProject;
    // const goal = goals?.[0]?.name ?? null;
    // const goalId = allGoalsList?.find(item => item.name == goal)?.id ?? null;
    const tags = [];
    let endDateTime = null;
    let startDateTime = date;
    // let startTime = 0;
    // let endTime = 0;

    if(!title.length){
      return;
    }

    // if(onStartTimeChange && onEndTimeChange){
    //   startTime = moment(onStartTimeChange).format('HH:mm')
    //   endTime = moment(onEndTimeChange).format('HH:mm')
    //   startTime = parseInt(startTime.split(':')[0]) * 60 + parseInt(startTime.split(':')[1])
    //   endTime = parseInt(endTime.split(':')[0]) * 60 + parseInt(endTime.split(':')[1])
    //   if(startTime > 0 && endTime > 0){
    //     endDateTime = date ? new Date(moment(date).startOf('date').add(endTime, 'minutes')).toISOString() : date
    //     startDateTime = date ? new Date(moment(date).startOf('date').add(startTime, 'minutes')).toISOString() : date
    //   }
    // }

    let taskData = {
      "id": item?.id,
      "title": item.title,
      "description": taskDescription ?? '',
      "tags": item?.tags,
      "goalId": null, //goalId,
      "project": item?.project,
      "repeat": item?.repeat ?? null,
      "date": item?.date ?? null,
      "endDateTime": item?.endDateTime ?? null,
      "orgRepeatId": item?.orgRepeatId ? item?.orgRepeatId : (item?.repeat?.rule ? item?.id : null)
    };

    let requestBody = {
      "id": item?.id,
      "title": title,
      "description": taskDescription ?? '',
      "tags": tags,
      "goalId": null, //goalId,
      "project": project,
      "repeat": repeatListOptions.filter(item => item.value === selectedRepeat)?.[0] ?? null,
      "date": startDateTime,
      "endDateTime": endDateTime,
      "orgRepeatId": item?.orgRepeatId ? item?.orgRepeatId : (item?.repeat?.rule ? item?.id : null)
    };

    if(!item?.id){
      return setUpdatedValue({...item, ...requestBody});
    }

    // if (updatedTitle) {
    try {
      let repeat = null;
      const editedDate = dateRange ?? (groupDate ? groupDate : dateChange);
      
      if(recurring !== null && recurring !== 3){
        const rruleSet = rrulestr(item?.repeat?.rule, {
          forceset: true,
        })
        // If this is a recurring task and want to edit the current occurrence only
        if(recurring == 1){
          rruleSet.exdate(momentTimezone(editedDate).tz(momentTimezone.tz.guess()).endOf('day').toDate())
          rruleSet.exdate(momentTimezone(groupDate ? groupDate : dateChange).tz(momentTimezone.tz.guess()).endOf('day').toDate())
        }else{
          
          if(recurring == 2){
            // If this is a recurring task and want to edit the current occurrence and all future occurrences of the task
            const rrule = new RRule({...(RRule.parseString(rruleSet._rrule.toString())), until: momentTimezone(editedDate).tz(momentTimezone.tz.guess()).add(-1, 'days').endOf('day').toDate()});
            rruleSet._rrule[0] = rrule;
            rruleSet.rrule(rrule);
          }
        }

        repeat = {...item?.repeat, rule: rruleSet.toString()};
      }else{
        if(date === null){
          repeat = null;
        }else{
          repeat = requestBody.repeat;
          // If task is set to recurring and orgRepeatId is not set, then set it to the current id
          if(repeat?.rule && !requestBody?.orgRepeatId){
            requestBody.orgRepeatId = item?.id;
          }
        }
        taskData = {...requestBody};
      }

      await updateTaskList({...taskData, repeat})
      delete taskData.project;
      delete taskData.tags;
      taskData = {...taskData, repeat, Project: project ? {title: project} : null, Tags: tags ? tags.map((tag, index) => ({name: tag, id: index+1})) : []};
      switch (currentPage) {
        case 'upComing':
          dispatch(updateGroupedList(taskData))
          break;
        case 'noDate':
          dispatch(updateNoDateTaskList(taskData))
          break;
        case 'completedList':
          dispatch(updateCompletedTaskList(taskData))
          break;
        case 'allTask':
          dispatch(updateAllTaskList(taskData))
          break;
        case 'overDue':
          dispatch(updateOverDueTaskList(taskData))
          fetchAddTaskData()
          break;
        default:
          dispatch(updateSetTaskList(taskData));

      }
      setUpdatedValue(taskData);

      if(recurring !== null && recurring !== 3){
        delete requestBody.id;
        if(date === null){
          requestBody.repeat = null;
          requestBody.orgRepeatId = null;
        }else{
          if(requestBody?.repeat?.rule){
            const rruleSet = rrulestr(requestBody?.repeat?.rule, {
              forceset: true,
            })
            let rruleOptions = {dtstart: momentTimezone(requestBody.date).tz(momentTimezone.tz.guess()).endOf('day').toDate()}
            if(recurring == 1){
              rruleOptions = {...rruleOptions, until: momentTimezone(requestBody.date).tz(momentTimezone.tz.guess()).endOf('day').toDate()}
            }else{
              rruleOptions = {...(RRule.parseString(rruleSet._rrule.toString())), ...rruleOptions}
            }
            const rrule = new RRule(rruleOptions);
            rruleSet._rrule[0] = rrule;
            rruleSet.rrule(rrule);
  
            requestBody.repeat = {...requestBody?.repeat, rule: rruleSet.toString()};
          }
        }

        let response = await createTask(requestBody)
        if(response?.data?.responseData?.data){
          response.data.responseData.data.Project = project ? {title: project} : null
          response.data.responseData.data.Tags = tags ? tags.map((tag, index) => ({name: tag, id: index+1})) : [];
        }
        switch (currentPage) {
          case 'upComing':
            dispatch(pushGroupedList(response?.data?.responseData?.data))
            break;

          case 'overDue':
            dispatch(pushOverDueTaskList(response?.data?.responseData?.data))
            break;

          case 'allTask':
            dispatch(pushAllTaskList(response?.data?.responseData?.data))
            break;

          case 'noDate':
            dispatch(pushNoDateTaskList(response?.data?.responseData?.data))
            break;
          case 'completedList':
            dispatch(pushCompletedTaskList(response?.data?.responseData?.data))
            break;
          default:
            dispatch(pushSetTaskList(response?.data?.responseData?.data));
        }
      }
      setEditTaskSelected('DatePicker')
      setEditTaskListData(true);
      setSelectedDate(dateTime)
      if(project){
        let projects = [];
        if(taskProjects.find(item => item.title.toLowerCase() == project.toLowerCase())){
          projects = taskProjects;
        }else{
          projects = [{title: project}, ...taskProjects];
        }
        dispatch(setTaskProjects(projects))
      }
      reloadProjectTasks();

      // Capture add task event
      captureEvent('Task Updated', {
        project: project
      });

      if(project?.length > 0){
        getProjects();
      }

      // if (dateTime == selectedDate) {
      //   fetchAddTaskData()
      // }
    } catch (e) {
      //console.log('ERROR', e)
    }
    // }
  }

  const onClickDateRangeSet = (day) => {
    setEditTaskSelected(day)
  }

  // Fetch projects list
  const getProjects = async () => {
    const {data} = await fetchProjectList();
    const projects = data?.responseData?.data ? data?.responseData?.data?.map(option => ({value: option.title, label: option.title})) : [];
    dispatch(setAllProjectsList(projects))
  }

  // Fetch projects list
  // const getGoals = async () => {
  //   const {data} = await fetchGoalList();
  //   const goals = data?.responseData ?? [];
  //   dispatch(setAllGoalsList(goals))
  // }

  useEffect(() => {
    let currentTime = moment().format('MM/DD')
    if (item) {
      let title = item?.title;
      if (item?.Project?.title) {
        title += ` @${item.Project.title}`;
      }
      // if (item?.Tags?.length > 0) {
      //   item.Tags.forEach((tag) => {
      //     title += ` #${tag.name}`;
      //   });
      // }

      setTitle(title);
    }
    if (currentPage == "overDue") {
      setEditTaskSelected("DatePicker")
    } else {
      if (currentPage == 'noDate') {
        setEditTaskSelected("No Date")
      } else if (moment(dateRange).format('MM/DD/YYYY') == moment().format('MM/DD/YYYY')) {
        setEditTaskSelected("Today")
      } else if (moment().add(1, 'days').format('MM/DD/YYYY') == moment(dateRange).format('MM/DD/YYYY')) {
        setEditTaskSelected("Tomorrow")
      } else if (moment().add(7, 'days').format('MM/DD/YYYY') == moment(dateRange).add(7, 'days').format('MM/DD/YYYY')) {
        setEditTaskSelected("Next Week")
      } else {
        setEditTaskSelected("DatePicker")
      }
    }

    getProjects();
    // getGoals();
    setTimeout(() => {
      setAutoFocus(true)
    }, 1)
  }, [])

  useEffect(() => {
    initRepeatListOptions();
  }, [dateRange])

  const CustomStyle = {
    singleValue: (base, state) => {
      return {
        ...base,
        background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
        lineHeight: 'normal',
        WebkitTextFillColor: 'transparent',
        WebkitBackgroundClip: 'text !important'
      }
    },
   option: (base, state) => {
      let background = 'var(--theme-mode-color-white)';
      let color = 'var(--theme-mode-color-white-reverse)';
      let backgroundImage = 'none';
      let backgroundPosition = '0 0';
      let opacity = 1;
      let fontWeight = '400';
      // const isFirstOption = state.options.indexOf(state.data) === 0;
      
      // if (isFirstOption) {
      //   opacity = 0.5;
      // }

      if (state.isFocused) {
        background = `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.9),rgba(var(--theme-mode-rgb-white),0.9)),var(--accent-color) !important`;
      }

      if (state.isSelected) {
        //color = "white !important";
        fontWeight = '600';
        background = `transparent url('data:image/svg+xml;charset=UTF-8,%3Csvg width%3D%2214%22 height%3D%2210%22 viewBox%3D%220 0 14 10%22 fill%3D%22none%22 xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath d%3D%22M13 1L4.75 9.25L1 5.5%22 stroke%3D%22${(theme == 'dark' ? colorPickerDark : colorPicker).replace(/^#/, '%23')}%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22/%3E%3C/svg%3E') no-repeat !important`;
        backgroundPosition = 'right 20px center !important';
      }

      return {
        ...base,
        color,
        background,
        backgroundImage,
        backgroundPosition,
        opacity,
        fontWeight
      };
    }
  } 

  const setCustomRule = (value) => {
    if(value?.rule){
      setSelectedRepeat(99);
      setRepeatListOptions(options => options.map(option => option.value === 99 ? {...option, ...value} : option));
    }else{
      setOpenCustomRepeat(value);
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
      e.preventDefault(); // Prevent default form submission
      onAddTaskUpdateHandler();
    }
  };

  const onChangeHandler = (mentions) => {
    if(mentions.length > 0){
      setSelectedProject(mentions[mentions.length - 1].name) 
    }else{
      setSelectedProject(null)
    }
  }

  return (
    <li className="li-task-list edit-list bg-white dark:bg-black">
      <form onSubmit={(e) => {
          e.preventDefault();
          onAddTaskUpdateHandler();
      }}
      css={{
        borderRadius: "15px",
        background: `linear-gradient(270deg, var(--theme-mode-color-white) 0%, rgba(var(--theme-mode-rgb-white), 0.80) 100%), linear-gradient(0deg, var(--accent-color) 0%, var(--accent-color) 100%), var(--theme-mode-color-white)`
      }}
      >
        <div className="filed-type"  style={{ borderBottom: theme == "dark" ? "1px solid white" : "" }}>
          {
            allProjectsList !== null && autoFocus &&
            <MediumLikeEditorWithMentions id="editTaskInputField" onChange={onChangeHandler} ref={editorRef} projects={allProjectsList} taskTitle={titleValue} taskDescription={taskDescription} handleKeyPress={handleKeyPress} setFocus={autoFocus} currentPage={currentPage} selectedProject={selectedProject} classNames="add-task-input focus-input" />
          }
        </div>
        <div className='repetions-block' style={{ display: "inline-block" }}>
          <div className="task-repetions">
            {
              hideActions === false
              &&
              <div className="add-repetions">
                <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}
                  onClick={() => onClickDateRangeSet('DatePicker')}>
                    <CalendarIcon color="gray" width={14} height={14} />
                    <span className="sl-ico" css={{
                        background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
                        whiteSpace: 'nowrap'
                      }}>
                        {
                          editTaskSelected == "DatePicker" ? (taskDate ? moment(taskDate).format('D MMM YYYY') : 'No Date') : editTaskSelected
                        }
                    </span>
                  <Datepicker
                    onChange={(date) => { setDateRange(date); setDatePickerValue(date); setTaskDate(date) }}
                    value={currentPage == "overDue" ? new Date(item?.date) : dateRange}
                  />
                </div>
                {/* {
                  isValidDate(dateRange) &&
                  <>
                    <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}>
                        <DateTimePicker
                          selected={onStartTimeChange}
                        onChange={(date) => {
                          setOnStartTimeChange(date)
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        showTimeCaption={false}
                        minTime={new Date().setHours(0, 0)}
                        maxTime={onEndTimeChange}
                        className="w-[60px] light-primary-color dark:bg-black outline-[0]"
                      />
                    </div>
                    <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}>
                        <DateTimePicker
                          selected={onEndTimeChange}
                          onChange={(date) => setOnEndTimeChange(date)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={30}
                          dateFormat="h:mm aa"
                          showTimeCaption={false}
                          minTime={onStartTimeChange}
                          maxTime={new Date().setHours(23, 59)}
                          className="w-[60px] light-primary-color dark:bg-black outline-[0]"
                        />
                    </div>
                  </>
                } */}
                {
                  isValidDate(dateRange) 
                  &&
                  <div
                    ref={repeatOptionsRef}
                    className='cs-select recurring-options-dropdown text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black'>
                    <Select
                        styles={CustomStyle}
                        onChange={(value) => value.value === 100 ? setOpenCustomRepeat(true) : setSelectedRepeat(value.value)}
                        options={repeatListOptions.filter(option => option.label !== null)}
                        value={repeatListOptions.filter(option => option.value === selectedRepeat)[0]}
                        classNamePrefix={"repeating-task-setting" || ""}
                        classNames={{container: () => 'react-select repeated-task-select', control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />
                    {
                      openCustomRepeat
                      &&
                      <RepeatedTaskModal targetRef={repeatOptionsRef} onHide={(value = null) => setCustomRule(value)} task={{...item, date: dateRange || new Date()}} />
                    }
                  </div>
                }
                
                <div ref={projectOptionsRef} className={`cs-select projects-tags-dropdown text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}
                    css={{
                      '.repeated-task-select': {
                        '.repeating-task-setting__menu-list': {
                          maxHeight: '300px !important'
                        }
                      },
                      '.tooltip-hover':{
                        '&:hover':{
                          '&::after':{
                            height: '75% !important'
                          }
                        }
                      },
                      '&.active': {
                        '.tooltip-hover':{
                          '&:hover':{
                            '&::after':{
                              display: 'none !important'
                            },
                            '~ span.tooltip-text':{
                                display: 'none !important'
                            }
                          }
                        }
                      }
                    }}>
                      <Tooltip className='overDue-tooltip tooltip-mt0' text="Type '@' to assign this task to a project">
                          <a className="hovr-btn tooltip-hover">
                            <Select
                              styles={CustomStyle}
                              placeholder="Project"
                              onChange={(value) => setSelectedProject(value.value)}
                              options={[{value: null, label: 'None'}, ...(allProjectsList ? allProjectsList : [] )]}
                              value={allProjectsList?.filter(option => option.value === selectedProject)?.[0] ?? null}
                              classNamePrefix={"repeating-task-setting"}
                              onMenuOpen={() => projectOptionsRef.current.classList.add('active')}
                              onMenuClose={() => projectOptionsRef.current.classList.remove('active')}
                              classNames={{container: () => 'react-select repeated-task-select', control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                            />
                          </a>
                      </Tooltip>
                </div>
              </div>
            }
            
            <div className="repetions-action">
              <div className="repeTions">
                <button className="recAct-btn cancel-btn border border-black/5 text-black dark:!text-white/50 bg-white dark:!bg-black"
                onClick={() => { setEditTaskId(null) }}>Cancel</button>
                <div style={{position: 'relative'}}>
                  <button type='submit' className="recAct-btn save-btn border border-black/5 text-white bg-[var(--accent-color-theme)]">Save</button>
                  {
                    editRecurringTask && <ConfirmRecurringTask iconComponent={<SaveIcon />} onHide={() => setEditRecurringTask(false)} theme={theme} onConfirm={(recurring) => onAddTaskUpdate(item, recurring)} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </li>
  )
}

export default EditTaskList